import axios from 'axios';
import { call, all, put, takeLatest, select } from 'redux-saga/effects';
import { startOfDay, endOfDay, format } from 'date-fns';

import * as commissionReportActions from './commission-report-actions';

import { saveAs } from 'file-saver';

import { GET_LIST_ALL_REQUEST, SHARE_CSV, GET_DETAILS_REQUEST } from './commission-report-constants';

import notification from '~/services/notification';
import commissionReportServices from './commission-report-service';

import { ISA_ERROR, USER_ROLE } from '~/constants';

import { AppStateType } from '../root-reducer';

import { formatDateTime, formatMessage } from '~/i18n/translate';
import { UserInterface } from '@e3labs/isa-data-dictionary';

let cancel: any;

const DATE_FORMAT = 'yyyy-MM-dd HH:mm:ss';
const CancelToken = axios.CancelToken;

export function* getAllCommissionReportReport({ type, filters }: { type: any; filters?: any }) {
  if (cancel !== undefined) cancel();
  const cancelToken = new CancelToken(function executor(c) {
    cancel = c;
  });
  try {
    yield put(commissionReportActions.setLoadingData(true));

    const { rowsPerPage, page, order, orderBy } = yield select((state: AppStateType) => state.commissionReport.list);
    const params = {
      skip: page === 0 ? 0 : page * rowsPerPage,
      limit: rowsPerPage,
      order,
      orderBy,
      ...commissionReportServices.formatPeriodsParams(filters)
    };

    const [{ data: successCommissionReports }] = yield all([
      call(
        commissionReportServices.getListSuccessCommissionReports,
        {
          ...params
        },
        {
          cancelToken
        }
      )
    ]);

    yield put(
      commissionReportActions.getAllCommissionReportsSuccess({
        commissionReports: [...successCommissionReports]
      })
    );
  } catch (error) {
    yield put({ type: ISA_ERROR, error });
  } finally {
    yield put(commissionReportActions.setLoadingData(false));
  }
}

export function* shareCSV({ payload }: any) {
  const toast: any = notification.loading(formatMessage('commonLoadingMessage'));

  try {
    let data;

    const params = {
      ...commissionReportServices.formatPeriodsParams(payload)
    };
    if (payload.exportType === 'details') {
      data = yield call(commissionReportServices.getCSVSuccessCommissionReportsDetails, params);
    } else {
      data = yield call(commissionReportServices.getCSVSuccessCommissionReports, params);
    }

    const csv = data?.data;

    const reader = new FileReader();

    const blobFile = new Blob([csv], { type: 'text/csv;charset=utf-8;' });

    reader.readAsDataURL(blobFile);
    reader.onloadend = async function () {
      saveAs(blobFile, `Relatório de Comissão.csv`);
    };
  } catch (error) {
    yield put({ type: ISA_ERROR, error });
  } finally {
    toast.close();
  }
}
export function* getCommissionDetails({ payload }: any) {
  try {
    yield put(commissionReportActions.setLoadingDetails(true));
    const params = {
      ...commissionReportServices.formatPeriodsParams(payload.filters)
    };

    const { data } = yield call(commissionReportServices.getCommissionReportDetails, params);
    yield put(commissionReportActions.getCommissionDetailsSuccess(data));
  } catch (error) {
    yield put({ type: ISA_ERROR, error });
  } finally {
    yield put(commissionReportActions.setLoadingDetails(false));
  }
}

export default all([
  takeLatest(GET_LIST_ALL_REQUEST, getAllCommissionReportReport),
  takeLatest(SHARE_CSV, shareCSV),
  takeLatest(GET_DETAILS_REQUEST, getCommissionDetails)
]);
